import { render } from "./FullscreenButton.vue?vue&type=template&id=5c8d3bb0&scoped=true"
import script from "./FullscreenButton.vue?vue&type=script&lang=ts"
export * from "./FullscreenButton.vue?vue&type=script&lang=ts"

import "./FullscreenButton.vue?vue&type=style&index=0&id=5c8d3bb0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5c8d3bb0"

export default script